var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 11C59.598 11 69 20.3523 69 31.8889V58H27V31.8889C27 20.3523 36.402 11 48 11Z",
    stroke: "url(#paint0_linear_121_4961)",
    strokeWidth: 8.58065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2168 44.1035H78.2813V76.2809C78.2813 79.8352 75.4001 82.7164 71.8458 82.7164H24.6523C21.0981 82.7164 18.2168 79.8352 18.2168 76.2809V44.1035Z",
    stroke: "white",
    strokeWidth: 6.43548,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2168 44.1035H78.2813V76.2809C78.2813 79.8352 75.4001 82.7164 71.8458 82.7164H24.6523C21.0981 82.7164 18.2168 79.8352 18.2168 76.2809V44.1035Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6854 59.1201C54.6854 55.5658 51.8042 52.6846 48.2499 52.6846C44.6957 52.6846 41.8145 55.5658 41.8145 59.1201C41.8145 61.5438 43.1544 63.6547 45.1339 64.7522C45.068 65.0089 45.0329 65.278 45.0329 65.5553V74.136C45.0329 75.9131 46.4735 77.3537 48.2506 77.3537C50.0277 77.3537 51.4684 75.9131 51.4684 74.136V65.5553C51.4684 65.2778 51.4332 65.0084 51.3672 64.7515C53.346 63.6538 54.6854 61.5434 54.6854 59.1201Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_121_4961",
    x1: 48,
    y1: 2,
    x2: 47.7303,
    y2: 66.4989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752681,
    stopColor: "#00B1C6",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.1d8429e5481f09aedc3d629036a6f83c.svg";
export { ForwardRef as ReactComponent };